import React, { useContext, useState, useEffect } from 'react';
import styles from './Modal.module.css';
import { Context } from '../../index';
import Sound_play from '../../Utils/sound_play';
import { close_modal_sound, open_modal_sound } from '../../Utils/sounds';

function Modal({ ModelState, Component, props, setModelState, type, own_close }) {
    
    const { store } = useContext(Context);
    
    const [isVisible, setIsVisible] = useState(ModelState);
    const [isClosing, setIsClosing] = useState(false);
    const props_result = props ? props : {};
    useEffect(() => {
        if (ModelState) {
            setIsVisible(true);
            setIsClosing(false);
            Sound_play(open_modal_sound,store.sound)
        }
    }, [ModelState]);

    const closeModal = () => {

        setIsClosing(true); // Запускаем анимацию закрытия
        setTimeout(() => {
            // Sound_play(close_modal_sound,store.sound)
            setIsVisible(false); // Ожидаем завершения анимации и скрываем элемент
            setModelState(false);
        }, 100); // Время должно совпадать с длительностью анимации `fadeOut`
    };

    const handleModalClick = (e) => {
        e.stopPropagation();
    };
    if (!isVisible){
        return null;
    }
    return (
        <>
            {isVisible && (
                <div className={styles.modalBackground} onClick={closeModal}>
                    <div className={`${styles.contentElement} ${isClosing ? styles.fadeOut : styles.fadeIn}`} onClick={handleModalClick}>
                        <div className={`${styles.closeContainer} ${isClosing ? styles.fadeOut : styles.fadeIn}`} onClick={own_close ? props_result.closeModal : closeModal}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className={styles.element}>
                            {<Component props={props} closeModal={closeModal} ModelState={ModelState} setModelState={setModelState} />}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Modal;
